import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import measurementService from "../../services/measurementService";

const PrepareMeasurementView = ({ showPrepareView }) => {
    const localisedValues = useLanguageChange();

    const sendCancelMeasurementPrepareView = () => {
        measurementService.cancelMeasurementView();
    };

    return (
        <div className={clsx("process-waiting annotation-process-waiting", !showPrepareView && "d-none")} data-testid='prepare-measurement-view'>
            <div className='process-waiting-in custom-scroll'>
                <div className='process-waiting-box text-center'>
                    <div className='process-waiting-icon'>
                        <span className='for-icon icon-preparing-ar'></span>
                    </div>
                    <div className='process-waiting-text'>
                        <div className='process-waiting-text-bar'>{localisedValues?.preparing_ar_measurement}</div>
                    </div>
                    <div className='process-waiting-text-bottom' id='timeOutScreen_Measurement' style={{ display: "none" }}>
                        <div className='process-waiting-text-bottom-bar'>{localisedValues?.markup_ocr_upload_timeout}</div>
                        <div className='process-waiting-text-bottom-bar'>
                            <button className='btn' onClick={sendCancelMeasurementPrepareView}>
                                {localisedValues?.click_here}
                            </button>
                            {localisedValues?.to_return_to_video_and_try_again}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PrepareMeasurementView.propTypes = {
    showPrepareView: PropTypes.bool,
};

export default PrepareMeasurementView;
